export default {"src":"/_next/static/media/ssPoint2.fbcdd279.svg","height":15,"width":16,"blurWidth":0,"blurHeight":0};